type Opaque<T, Brand extends string> = T & { readonly __brand: Brand };

export type EventId = Opaque<string, "EventId">;
export const asEventId = (raw: string) => raw as EventId;

export type BuildId = Opaque<string, "BuildId">;
export const asBuildId = (raw: string) => raw as BuildId;

export type CalibrationId = Opaque<string, "CalibrationId">;
export const asCalibrationId = (raw: string) => raw as CalibrationId;

export type BoatId = Opaque<string, "BoatId">;
export const asBoatId = (raw: string) => raw as BoatId;

export type TeamId = Opaque<string, "TeamId">;
export const asTeamId = (raw: string) => raw as TeamId;

export type CalibrationState = "initial" | "draft" | "golden";

export type PhotoId = Opaque<string, "PhotoId">;
export const asPhotoId = (raw: string) => raw as PhotoId;

export type PhotoCategoryId = Opaque<string, "PhotoCategoryId">;
export const asPhotoCategoryId = (raw: string) => raw as PhotoCategoryId;

export type CountryCode = Opaque<string, "CountryCode">;
export const asCountryCode = (raw: string) => raw as CountryCode;

export type BoatCode = Opaque<string, "BoatCode">;
export const asBoatCode = (raw: string) => raw as BoatCode;

export type ReleaseId = Opaque<string, "ReleaseId">;
export const asReleaseId = (raw: string) => raw as ReleaseId;

export type EventReleaseId = Opaque<string, "EventReleaseId">;
export const asEventReleaseId = (raw: string) => raw as EventReleaseId;

export type ToeCheckId = Opaque<string, "ToeCheckId">;
export const asToeCheckId = (raw: string) => raw as ToeCheckId;

export type YawCheckId = Opaque<string, "YawCheckId">;
export const asYawCheckId = (raw: string) => raw as YawCheckId;

export type ScheduleSlotId = Opaque<string, "ScheduleSlotId">;
export const asScheduleSlotId = (raw: string) => raw as ScheduleSlotId;

export type PlatformWeighingId = Opaque<string, "PlatformWeighingId">;
export const asPlatformWeighingId = (raw: string) => raw as PlatformWeighingId;

export type WingWeighingId = Opaque<string, "WingWeighingId">;
export const asWingWeighingId = (raw: string) => raw as WingWeighingId;

export type EventCorrectorStateId = Opaque<string, "EventCorrectorStateId">;
export const asEventCorrectorStateId = (raw: string) =>
  raw as EventCorrectorStateId;

export type WingConfig = "HAW" | "APW" | "LAW";

export type CorrectorSlot =
  | "TRANSOM_P"
  | "TRANSOM_S"
  | "FC_SEAT_P"
  | "FC_SEAT_S"
  | "POD"
  | "WETBOX_P"
  | "WETBOX_S"
  | "DB_RAKE_RAM_P"
  | "DB_RAKE_RAM_S"
  | "BOW_SHELF_P"
  | "BOW_SHELF_S";

export type WeighingState = "draft" | "signed_off" | "superseded";
